import React, {
  useState,
} from "react"
import {
  Button,
  Form,
  Segment,
  Header,
  Checkbox,
  Message,
} from "semantic-ui-react"
import axios from "axios"
import { useNavigate } from "react-router-dom"

const LoginPage = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [rememberMe, setRememberMe] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  const navigate = useNavigate()

  const onLoginPress = async () => {
    try {
      const {
        data: {
          accessToken = '',
          refreshToken = '',
        } = {},
      } = await axios.post('/userLogin', {
        email,
        password,
      })

      sessionStorage.setItem('accessToken', accessToken)
      if (rememberMe) localStorage.setItem('refreshToken', refreshToken)
      setErrorMessage("")

      navigate("/BankReconciliation")
    } catch (err) {
      console.error(err)
      const {
        message: errMessage = '',
        response: {
          data: {
            message = '',
          } = {},
        } = {},
      } = err
      setErrorMessage(message || errMessage || JSON.stringify(err))
      // setErrorMessage(JSON.stringify(err))
    }
  }

  const onForgotPasswordPress = () => {
    navigate("/ForgottenPassword", {
      state: { email },
    })
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#1e1e1e",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Segment
        padded
        raised
        style={{
          maxWidth: 400,
          width: "100%",
          backgroundColor: "#2c2f33",
          color: "white",
        }}
      >
        <Header as="h2" textAlign="center" style={{ color: "white" }}>
          Connexion
        </Header>
        <Form>
          <Form.Input
            label={{ children: "Email", style: { color: "white" } }}
            placeholder="votre@email.com"
            type="email"
            style={{ color: "white" }}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Form.Input
            label={{ children: "Mot de passe", style: { color: "white" } }}
            placeholder="••••••••"
            type="password"
            style={{ color: "white" }}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Form.Field>
            <Checkbox
              label={<label style={{ color: "white" }}>Se souvenir de moi</label>}
              onChange={() => setRememberMe(!rememberMe)}
            />
          </Form.Field>
          <Button
            fluid
            style={{ backgroundColor: "#2897d5", color: "white" }}
            onClick={onLoginPress}
          >
            Se connecter
          </Button>
        </Form>
        {!!errorMessage && (
          <Message error content={errorMessage} />
        )}
        <div style={{ marginTop: "1em", textAlign: "center" }}>
          <Button basic inverted size="small" onClick={onForgotPasswordPress}>
            Mot de passe oublié ?
          </Button>
        </div>
      </Segment>
    </div>
  )
}

export default LoginPage
